export function formatDate(dateString: string | null): string {
  if (!dateString) return '-';

  // 1) Datum aus dem ISO-String parsen (UTC-Interpretation)
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-'; // ungültiges Datum abfangen

  // 2) Lokale Zeitzone des Nutzers ermitteln
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // 3) Datum/Uhrzeit im deutschen Format (ohne Wochentag & Zeitzone)
  const germanOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: userTimeZone
  };
  const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
  const germanFormatted = germanFormatter.format(date);

  // 4) Wochentag separat formatieren (neutral / nördliche Sprache)
  const weekdayFormatter = new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    timeZone: userTimeZone
  });
  const weekday = weekdayFormatter.format(date);

  // 5) Wochentag + Datum/Uhrzeit kombinieren
  const formattedDate = `${weekday}, ${germanFormatted}`;

  // 6) Zeitdifferenz berechnen
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  const timeAgo =
    diffMinutes < 1
      ? 'gerade eben'
      : diffMinutes < 60
        ? `vor ${diffMinutes} Minuten`
        : diffHours < 24
          ? `vor ${diffHours} Stunden`
          : `vor ${diffDays} Tagen`;

  // 7) Finalen String zurückgeben
  return `${formattedDate} (${timeAgo})`;
}

export function formatDateOnly(dateString: string | null): string {
  if (!dateString) return '-';

  // 1) Datum aus dem ISO-String parsen
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-'; // ungültiges Datum abfangen

  // 2) Datum im deutschen Format (ohne Uhrzeit)
  const germanOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
  const germanFormatted = germanFormatter.format(date);

  // 3) Formatiertes Datum zurückgeben
  return germanFormatted;
}
